import classNames from 'classnames';
import styles from './index.module.scss';
import Tooltip from '../Tooltip';
import {ExternalTipsDocSvg} from '@/icons';
import Icon, {IconSize} from '../Icon';
import externalDocPng from '@/assets/img/externalDocPng.png';
import {externalRepoAddPowerUrl} from '@/Constant';

interface externalLabelProps {
    labelName: string;
    tipsDisabled?: boolean;
    className?: string;
}
export default function ExternalLabel(props: externalLabelProps) {
    const {labelName = '', tipsDisabled = true, className} = props;
    const isTocPage = window.isTocPage;

    function handleClick() {
        window.open(externalRepoAddPowerUrl);
    }

    if (isTocPage) {
        return null;
    }

    return (
        <>
            {
                tipsDisabled
                    ? <div className={classNames(styles.external, className)}>
                        {labelName}
                    </div>
                    : <Tooltip
                        content={<div className={styles.tooltipContent}>
                            <div className={styles.tooltipTop}>当前为「外部协同知识库」，该知识库内容可分享给公司外部用户，</div>
                            <div className={styles.tooltipFooter}>
                                <div>请注意数据绿色围墙。详情可见：</div>
                                <div className={styles.docLink} onClick={handleClick}>
                                    <img src={externalDocPng} className={styles.backImg} />
                                    <span>外部知识库账户授权流程</span>
                                </div>
                            </div>
                        </div>}
                        className={styles.externalTag}
                        type={'hover'}
                        placement="bottom"
                    >
                        <div className={classNames(styles.external, className)}>
                            {labelName}
                        </div>
                    </Tooltip>
            }
        </>
    );
}
